import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFireFill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	id: "svg1",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { id: "defs1" }), /* @__PURE__ */ _jsx("path", {
		id: "path2",
		d: "m 12.757813,2.2519531 c -0.134525,0.00862 -0.26616,0.052728 -0.38086,0.1328125 -0.2294,0.1601699 -0.350653,0.4354909 -0.314453,0.7128907 0.1842,1.4097785 0.09296,3.321374 -0.369141,4.8515624 C 11.46226,8.714288 11.155362,9.3300979 10.789063,9.7421875 10.492863,10.075477 10.169574,10.264906 9.8027344,10.316406 9.6988445,10.057907 9.5964262,9.6608289 9.5039063,9.1933594 9.3114964,8.2212303 9.2109375,7.1804298 9.2109375,7 9.2109375,6.7190903 9.0524841,6.4625542 8.8027344,6.3339844 8.5529846,6.2054145 8.2540204,6.2274152 8.0253906,6.390625 7.636111,6.6685147 6.7966128,7.4499747 6.5019531,7.7402344 0.46826616,13.496859 5.8436543,23.283073 13.847656,21.546875 c 3.065997,-0.512399 5.14157,-2.520887 6.105469,-5.021484 0.957799,-2.484698 0.826383,-5.464169 -0.478516,-8.009766 -1.363498,-2.8313272 -3.669168,-4.7930789 -6.322265,-6.1796875 -0.124,-0.064795 -0.260007,-0.092604 -0.394531,-0.083984 z"
	})]
});
export default SvgFireFill;
